import React from 'react';
import { Box, Typography } from '@mui/material';
import PublisherLogo from '../publisherLogo';
import StatusPill from '../statusPill';
import * as styles from './styles';

function InactiveCard({ publisher = {}, app = {}, timezone, lastSyncedLabel }) {
    function renderApp() {
        if (!app.application) return null;
        return <Box sx={styles.metaPill}>{app.application}</Box>;
    }

    function renderDevice() {
        if (!app.device) return null;
        return <Box sx={styles.metaPill}>{app.device}</Box>;
    }

    function renderTimezone() {
        if (!timezone) return null;
        return <Box sx={styles.metaPill}>{timezone}</Box>;
    }

    function renderLastSynced() {
        if (!lastSyncedLabel) return null;
        return (
            <Typography sx={styles.metaText}>
                Last sync {lastSyncedLabel}
            </Typography>
        );
    }

    return (
        <Box component="article" sx={styles.card}>
            <Box sx={styles.header}>
                <PublisherLogo
                    logo={publisher.logo}
                    name={publisher.name}
                    size={48}
                />

                <Box sx={styles.publisherInfo}>
                    <Typography sx={styles.publisherName}>{publisher.name}</Typography>
                    <Box sx={styles.metaRow}>
                        <StatusPill isActive={false} />
                        {renderApp()}
                        {renderDevice()}
                        {renderTimezone()}
                        {renderLastSynced()}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default InactiveCard;
